import useBooleanConfig from './useBooleanConfig';

export default function useLeadManagementTourEntryPointEnabled(): boolean {
  return useBooleanConfig('enableLeadManagementTourEntryPoint', false);
}
